import DynamicForm from '../components/dynamicForm';

const JoinUs = () => {
  const fields = [
    { id: 'name', type: 'text', placeholder: 'الاسم', required: true },
    { id: 'mobile', type: 'phone', placeholder: 'رقم الجوال', required: true },
    { id: 'region', type: 'text', placeholder: 'المنطقة', required: true },
    { id: 'email', type: 'email', placeholder: 'البريد الإلكتروني', required: true },
    { id: 'gender', type: 'select', placeholder: 'الجنس', options: [{ label: 'ذكر', value: 'ذكر' }, { label: 'أنثى', value: 'أنثى' }], required: true },
    { 
      id: 'speciality', 
      type: 'select', 
      placeholder: 'التخصص المطلوب للتقديم', 
      options: [
        { label: 'وظائف إدارية', value: 'وظائف إدارية' },
        { label: 'وظائف مبيعات', value: 'وظائف مبيعات' },
        { label: 'وظائف موسمية', value: 'وظائف موسمية' }
      ],
      required: true 
    },
    { id: 'resume', type: 'file', placeholder: 'السيرة الذاتية', acceptFiles: 'application/pdf', required: true },
    
  ];

  return (
    <DynamicForm
      formType="JoinUs"
      fields={fields}
      title="انضم إلى فريقنا"
    />
  );
};

export default JoinUs;
